import requester from 'utils/requester';
import { showLoader, hideLoader } from 'actions/loader';
import * as types from './types';

export const loadTerms = () => async (dispatch) => {
  try {
    dispatch(showLoader());
    const markup = await requester({
      method: 'get',
      url: 'https://volia.com/ukr/offerta/',
      // обходим cors так как другой домен
      mode: 'no-cors',
      appendParams: false,
      extendHeadersWithSession: false,
    });
    // Делов том, что мы получаем разметку и из нее нужно достать только body
    const terms = new DOMParser().parseFromString(markup, 'text/html').querySelector('body');
    // Для того, чтобы вмонтированть в react другую разметку она должна быть в строковом представлении
    dispatch(setTerms(terms.innerHTML));
  } catch (error) {
    console.error('error');
  } finally {
    dispatch(hideLoader());
  }
};

const setTerms = (payload) => ({ type: types.SET, payload });
